<template lang="pug">
.row.mt-4(v-if="loaded && employee_logs.length != 0")
  .col-12
    h3 Логи сотрудников
  .col-12.white_block(v-if="employee_logs.length == 0")
    .not_found На данный момент нет логов сотрудников.
  .col-12.white_block(v-else)
    vue-good-table(
      :columns="employee_logs_columns",
      :rows="employee_logs",
      :search-options="{ enabled: true, skipDiacritics: true, placeholder: 'Поиск по логам' }",
      :pagination-options="{ enabled: true, perPage: 50, nextLabel: 'Дальше', prevLabel: 'Назад', ofLabel: 'из', pageLabel: 'страница', allLabel: 'Всё', rowsPerPageLabel: 'Строк на странице' }",
      styleClass="datatable vgt-table condensed",
      :sort-options="{ enabled: true, initialSortBy: { field: 'id', type: 'desc' } }"
    )
</template>

<script>
export default {
  props: ["employee_logs", "loaded", "employee_logs_columns"],
  data() {
    return {};
  },
};
</script>